var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOutlineTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 19,
    viewBox: "0 0 21 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4932 4.58816C18.5059 4.78842 18.5059 4.98873 18.5059 5.18899C18.5059 11.2972 14.3867 18.3354 6.85791 18.3354C4.53844 18.3354 2.38377 17.5772 0.571289 16.2612C0.900841 16.3041 1.21768 16.3184 1.55991 16.3184C3.47375 16.3184 5.23554 15.5888 6.64243 14.3443C4.84263 14.3014 3.33435 12.971 2.81468 11.1399C3.06819 11.1828 3.32167 11.2114 3.58786 11.2114C3.95541 11.2114 4.323 11.1542 4.6652 11.0541C2.78936 10.6249 1.38243 8.76526 1.38243 6.51936V6.46216C1.92742 6.80549 2.5612 7.02006 3.23291 7.04864C2.13022 6.21892 1.40779 4.80273 1.40779 3.20055C1.40779 2.34226 1.61055 1.55547 1.96546 0.868822C3.98073 3.67262 7.00999 5.50365 10.4068 5.70396C10.3434 5.36063 10.3054 5.00304 10.3054 4.6454C10.3054 2.09906 12.1305 0.0248413 14.3993 0.0248413C15.578 0.0248413 16.6427 0.58274 17.3905 1.48396C18.3157 1.2837 19.2029 0.897444 19.9888 0.368167C19.6845 1.44108 19.0382 2.3423 18.189 2.91446C19.0128 2.81438 19.8113 2.55683 20.5464 2.19924C19.9889 3.11473 19.2917 3.93009 18.4932 4.58816Z",
    fill: "#545776"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutlineTwitter);
export default __webpack_public_path__ + "static/media/outline-twitter.2dfb7ab7d59cbf76b8986db8196c4146.svg";
export { ForwardRef as ReactComponent };